<div class="modal-body p-0 flex-fill d-flex flex-column compact-form" *ngIf="!!data">
    <div class="card">
        <div class="card-body p-2 pb-3">
            <div class="btn-toolbar mx-0 mb-1 mt-0">
                <div>
                    <button *ngIf="!hasChanges()" class="btn btn-sm btn-secondary ms-2 me-4" (click)="refresh()">Refresh Data</button>
                </div>
            </div>

            <dx-form *ngIf="data" [formData]="data" [colCount]="12">
                <dxi-item itemType="group" caption="Part Configurations" [colSpan]="3">
                    <dxi-item>
                        <div *dxTemplate>
                            <dx-file-uploader
                                name="fileUpload"
                                selectButtonText="Select File(s)"
                                class="attachments"
                                accept="*"
                                uploadMode="instantly"
                                [showFileList]="false"
                                [multiple]="true"
                                [uploadUrl]="uploadUrl"
                                [uploadHeaders]="uploadHeader"
                                (onUploadStarted)="uploadStarted($event)"
                                (onUploadError)="uploadError($event)"
                                (onUploaded)="configUploaded($event)"
                            >
                            </dx-file-uploader>
                        </div>
                    </dxi-item>
                    <!-- <dxi-item>
                        <div *dxTemplate>
                            <ul style="list-style-type: none; padding-inline-start: 0px" *ngIf="attachments">
                                <a title="view" href="" (click)="openAttachment(attachment)">{{ attachments.length }} Uploaded Attachments</a>
                                <button *ngIf="true" class="btn btn-sm btn-danger ml-4 mr-2" (click)="processAttachments()">Process Attachments</button>

                                <li *ngFor="let attachment of attachments">
                                    <a title="remove" (click)="removeAttachment($event, attachment)"> <i class="fa fa-times" aria-hidden="true"></i> </a>&nbsp;
                                    <a title="view" (click)="openAttachment(attachment)">{{ attachment.name }}</a>
                                </li>
                            </ul>
                        </div>
                    </dxi-item> -->
                </dxi-item>
                <dxi-item itemType="group" caption="Part Drawings (pdf)" [colSpan]="3">
                    <dxi-item>
                        <div *dxTemplate>
                            <dx-file-uploader
                                name="fileUpload"
                                selectButtonText="Select File(s)"
                                class="attachments"
                                accept="*"
                                uploadMode="instantly"
                                [showFileList]="false"
                                [multiple]="true"
                                [uploadUrl]="attachmentUploadUrl"
                                [uploadHeaders]="uploadHeader"
                                (onUploadStarted)="uploadStarted($event)"
                                (onUploadError)="uploadError($event)"
                                (onUploaded)="attachmentUploaded($event)"
                            >
                            </dx-file-uploader>
                        </div>
                    </dxi-item>
                </dxi-item>
            </dx-form>
        </div>
    </div>

    <div class="row" style="min-height: 300px">
        <div class="col-sm-2 m-2" style="padding-right: 0px">
            <dx-data-grid
                #attachmentsGrid
                keyExpr="id"
                class="lines-grid"
                [dataSource]="attachments"
                height="800"
                [columnAutoWidth]="false"
                (onToolbarPreparing)="onToolbarPreparingAttachments($event)"
                [showBorders]="true"
            >
                <dxi-column dataField="name" caption="FileName" width="250" cellTemplate="linkTemplate"></dxi-column>
                <dxi-column dataField="created" width="100"></dxi-column>
                <dxi-column width="10"></dxi-column>

                <div *dxTemplate="let cell of 'linkTemplate'">
                    <a [routerLink]="[]" (click)="openAttachment(cell.data)"> {{ cell.value }}</a>
                </div>

                <div *dxTemplate="let data of 'toolbarButtons'">
                    <button class="btn btn-sm btn-success me-2" (click)="processAttachments()" [disabled]="hasChanges()">Process Attachments</button>
                    <button class="btn btn-sm btn-danger" (click)="deleteConfigurationAttachments()" [disabled]="attachmentsGrid.instance.getSelectedRowsData().length === 0">Delete</button>
                </div>
                <div *dxTemplate="let data of 'toolbarText'"></div>

                <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
                <dxo-export [enabled]="false"></dxo-export>
                <dxo-selection [mode]="'multiple'" showCheckBoxesMode="false"></dxo-selection>
            </dx-data-grid>
        </div>

        <div class="col-sm-4" style="padding-right: 0px">
            <div class="m-2">
                <dx-data-grid
                    #dataGrid
                    keyExpr="id"
                    class="lines-grid"
                    [dataSource]="partConfigurations"
                    height="800"
                    [columnAutoWidth]="false"
                    (onToolbarPreparing)="onToolbarPreparing($event)"
                    (onSelectionChanged)="onSelectionChanged($event)"
                    (onRowPrepared)="rowPreparePartConfigurations($event)"
                    (onExporting)="onExporting($event)"
                    [showBorders]="true"
                >
                    <dxi-column dataField="partNumber" caption="Part #" width="180"></dxi-column>
                    <dxi-column dataField="description" width="200"></dxi-column>
                    <dxi-column dataField="missingPartsCount" caption="Missing SubParts" width="150"></dxi-column>
                    <dxi-column></dxi-column>

                    <div *dxTemplate="let data of 'toolbarButtons'">
                        <button
                            class="btn btn-sm btn-success me-2"
                            (click)="createSinglePart(dataGrid.instance.getSelectedRowsData()[0])"
                            [disabled]="
                                dataGrid.instance.getSelectedRowsData().length !== 1 ||
                                dataGrid.instance.getSelectedRowsData()[0].partId ||
                                dataGrid.instance.getSelectedRowsData()[0].missingPartsCount > 0
                            "
                        >
                            Create
                        </button>
                        <button class="btn btn-sm btn-success me-2" (click)="createAll()">Create All</button>
                        <button
                            class="btn btn-sm btn-success me-2"
                            (click)="process(dataGrid.instance.getSelectedRowsData())"
                            [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
                        >
                            Process Selected
                        </button>
                        <button class="btn btn-sm btn-success me-2" (click)="process(partConfigurations)">Process All</button>
                        <button class="btn btn-sm btn-danger ml-1" (click)="deletePartConfiguration()" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">
                            Delete
                        </button>
                    </div>
                    <div *dxTemplate="let data of 'toolbarText'"></div>

                    <dxo-export [enabled]="true"></dxo-export>
                    <dxo-selection mode="multiple"></dxo-selection>
                    <dxo-state-storing [enabled]="true" [storageKey]="'partConfigurations-grid'"></dxo-state-storing>
                </dx-data-grid>
                <div class="d-flex">
                    <div class="column ml-2 mr-3"><span class="color-legend no-part"></span> - No Matching Part</div>
                </div>
                <div class="d-flex flex-column"></div>
            </div>
        </div>

        <div class="col-sm-5" style="padding-right: 0px">
            <div class="m-2">
                <div class="d-flex">
                    <div class="column ms-2 me-2"><span class="color-legend with-border no-part"></span> - No Matching Part in Azure</div>
                    <div class="column ms-2 me-2"><span class="color-legend with-border matching-config-lines"></span> - Exact Match Found in Azure</div>
                    <div class="column ms-2 me-2"><span class="color-legend with-border new-config-lines"></span> - Part Found, Will be Added to Part Tree</div>
                    <div class="column ms-2 me-2"><span class="color-legend with-border removing-config-lines"></span> - In Existing Part Tree, but Missing in Config</div>
                </div>
                <dx-data-grid
                    #linesGrid
                    keyExpr="id"
                    class="lines-grid"
                    [dataSource]="partConfigurationLines"
                    height="800"
                    [columnAutoWidth]="false"
                    (onToolbarPreparing)="onToolbarPreparing($event)"
                    (onRowPrepared)="rowPreparePartConfigurationLines($event)"
                    (onExporting)="onExporting($event)"
                    [showBorders]="true"
                >
                    <dxi-column dataField="partNumber" caption="Part #" width="200"></dxi-column>
                    <dxi-column dataField="quantity" [editorOptions]="{ step: 0 }" caption="Qty" width="65"></dxi-column>
                    <dxi-column dataField="description" width="200"></dxi-column>

                    <dxi-column dataField="currentPartNumber" caption="Current Part #" width="200"></dxi-column>
                    <dxi-column dataField="currentQuantity" [editorOptions]="{ step: 0 }" caption="Current Qty" width="65"></dxi-column>
                    <dxi-column dataField="currentDescription" width="200"></dxi-column>

                    <dxi-column width="100"></dxi-column>

                    <div *dxTemplate="let data of 'toolbarButtons'">
                        <button
                            class="btn btn-sm btn-success"
                            (click)="createSubPart(linesGrid.instance.getSelectedRowsData()[0])"
                            [disabled]="linesGrid.instance.getSelectedRowsData().length !== 1 || linesGrid.instance.getSelectedRowsData()[0].partId"
                        >
                            Create
                        </button>
                        <!-- <button class="btn btn-sm btn-danger ml-4" (click)="addInvoiceLine()" [disabled]="hasChanges()" [hidden]="showAsDialog || !canAddDetails">
                            Add Invoice Line from Build Detail
                        </button> -->
                    </div>
                    <div *dxTemplate="let data of 'toolbarText'"></div>

                    <dxo-export [enabled]="true"></dxo-export>
                    <dxo-selection mode="multiple"></dxo-selection>
                    <dxo-state-storing [enabled]="true" [storageKey]="'partConfiguration-lines-grid'"></dxo-state-storing>
                </dx-data-grid>
            </div>
        </div>
    </div>
</div>
